import { render } from "./LoginArea.vue?vue&type=template&id=77847457&scoped=true"
import script from "./LoginArea.vue?vue&type=script&lang=js"
export * from "./LoginArea.vue?vue&type=script&lang=js"

import "./LoginArea.vue?vue&type=style&index=0&id=77847457&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77847457"]])

export default __exports__